module.exports = __webpack_public_path__ + "static/media/Logo__GoldmanSachs.57228725.svg";